import {
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentManagementNavigatorComponent } from '../../master/content-management-navigator/content-management-navigator.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ToastrService } from 'ngx-toastr';
import {
  ExamManagementService,
  IGetMockExamApplicableCoursePlanResponse,
} from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { AddEditMockExamModalComponent } from '../add-edit-mock-exam-modal/add-edit-mock-exam-modal.component';
import { IGetCodes } from 'src/app/interfaces/codes';
import { ICoursePlanMockExam, IMockExam } from 'src/app/Models/ExamAgencies';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sort.directive';
import { compare } from '../exam-agencies/exam-agencies.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationAddEditComponent } from 'src/app/Component/notification-management/notification-add-edit/notification-add-edit.component';

@Component({
  selector: 'app-mock-exams',
  templateUrl: './mock-exams.component.html',
  styleUrls: ['./mock-exams.component.css'],
})
export class MockExamsComponent implements OnInit {
  courseId: string = '';
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  currentRoute: string = '';
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  courses: IGetCodes[];
  mockExams: IMockExam[] = [];
  CourseAppliableCourseType: ICoursePlanMockExam[];
  public sortColumn: keyof any;
  public sortDirection: 'asc' | 'desc' | '' = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  unMockExams: IMockExam[];
  selectedRowId: number | null = null;


  constructor(
    private modalService: NgbModal,
    private modalServiceLocal: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    public service: ContentManagementService,
    public toastr: ToastrService,
    private ExamService: ExamManagementService,
    public session: SessionService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$),
        switchMap((queryParams) => {
          this.courseId = queryParams['c_id'];
          this.ExamAgencyName = queryParams['eA_Name'];
          this.CourseName = queryParams['c_Name'];
          this.ExamYear = queryParams['eY_Name'];
          return forkJoin({
            courseCodes: this.service
              .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course codes:', error);
                  return of([]);
                })
              ),
            coursePlans: this.service
              .getCoursePlan$(
                this.session.getUser(),
                +this.courseId,
                '',
                'ASSIGNMOCKEXAM',
                '',
                ''
              )
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course plans:', error);
                  return of(null);
                })
              ),
            applicableCoursePlans:
              this.ExamService.getMockExamApplicableCoursePlan({
                ScreenName: 'ASSIGNMOCKEXAMTOCOURSEPLAN',
                CourseTestID: null,
                CourseID: +this.courseId,
                CoursePlanID: null,
                SelectedInd: null,
              }).pipe(
                catchError((error) => {
                  console.error(
                    'Error fetching applicable course plans:',
                    error
                  );
                  return of(null);
                })
              ),
          });
        })
      )
      .subscribe(({ courseCodes, coursePlans, applicableCoursePlans }) => {
        this.getMockExams();
        this.courses = courseCodes;
        this.CourseAppliableCourseType = applicableCoursePlans;
      });

      this.ExamService.selectedExamId$.pipe(takeUntil(this.destroy$)).subscribe(id => {
        this.selectedRowId = id;
      });
  }

  setSelectedExamId(id: number | null) {
    this.ExamService.setSelectedExamId(id);
  }

  getMockExams() {
    const payload = {
      CourseID: +this.courseId,
      CoursePlanID: null,
      MockExamID: null,
      CalledFrom: 'MOCK EXAM MANAGEMENT',
    };
    this.ExamService.getMockExams(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.mockExams = res;
          this.unMockExams = res;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  checkedCoursePlan(type: string, testId: number): boolean {
    return this.CourseAppliableCourseType.some(
      (e) =>
        e.Course_Plan_Type_Code === type &&
        Number(e.Course_Test_Id) === Number(testId) &&
        e.Deleted_Ind === 'N'
    );
  }
  materialID:any

  AddEditExam(MockExam?: IMockExam) {
    const modalRef = this.modalService.open(AddEditMockExamModalComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.MockExam = MockExam || undefined;
    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
        this.materialID = result;
        // Perform actions after modal is closed
        this.CreateNotification()
        this.ngOnInit(); // Example: Refresh list after closing
      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

      async CreateNotification(): Promise<boolean> {
        try {
          // Step 1: Ask for confirmation
          const result = await this.modalServiceLocal.open(
            'Confirmation',
            'Do you want to send notification to all the users about this Mock Exam?',
            'Yes',
            'No'
          );

          if (!result) {
            return false; // user cancelled
          }

          // Step 2: Open notification modal
          const modalRef = this.modalService.open(NotificationAddEditComponent, {
            centered: true,
            size: 'xl',
            windowClass: 'custom-modal-width-notification-course',
            backdropClass: 'custom-backdrop-notification'
          });

          // Pass data into modal
          modalRef.componentInstance.screenName = 'MockExam';
          modalRef.componentInstance.MaterialId =this.materialID

          // Step 3: Wait for modal close result
          const notificationResult = await modalRef.result
            .then((res: any) => res)
            .catch(() => false);

          return !!notificationResult;
        } catch (error) {
          console.error('CreateNotification dismissed or failed:', error);
          return false;
        }
      }

  getPlanNameInitails(courseName: string) {
    if (courseName.split(' ')[1] === 'Plan') {
      return courseName.split(' ')[0];
    } else {
      return courseName;
    }
  }
  public onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || column === '') {
      this.mockExams = this.unMockExams;
      this.sortColumn = '';
      this.sortDirection = '';
    } else {
      this.sortColumn = column;
      this.sortDirection = direction;
      this.mockExams = [...this.unMockExams].sort((a: any, b: any) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  navigateToMockExamQuestions(item: IMockExam) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        m_Seq: item.Mock_Exam_Sequence_Number,
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/MockExamsQuestion', item.Course_Test_Id],
      navigationExtras
    );
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
    currentUrl.includes('Exam/MockExams') ||
      currentUrl.includes('Exam/MockExamsQuestion') ||
      currentUrl.includes('Exam/AddEditMockExamsQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null); // Clear the selection
    }
    this.destroy$.next(); // Emit value to trigger unsubscription
    this.destroy$.complete(); // Ensures Subject is fully closed
  }
}
